import Grid from "@material-ui/core/Grid";

import MaskAndValid from "utils/maskAndValid";
import Bignumber from "components/Bignumbers/Bignumber";
import { AttachMoney, ListAlt, Paid, Receipt } from "@mui/icons-material";

const getNonBilledOrders = (orders) => {
  const nonBilledOrders = orders.filter(
    (order) => order.StatusPedido?.toLowerCase().indexOf("cancelado") === -1
  );
  let nonBilledOrdersTotal = 0;

  nonBilledOrders?.forEach(
    (order) => (nonBilledOrdersTotal += order.ValorSaldoEmAberto)
  );

  return {
    nonBilledOrdersLength: orders.length,
    nonBilledOrdersTotal,
  };
};

const getBilledOrders = (orders) => {
  const billedOrders = orders.filter(
    (order) =>
      order.StatusPedido === "Totalmente Faturado" ||
      order.StatusPedido === "Parcialmente Faturado"
  );
  let billedOrdersTotal = 0;

  billedOrders?.forEach((order) => (billedOrdersTotal += order.ValorFaturado));

  return {
    billedOrdersLength: billedOrders.length,
    billedOrdersTotal,
  };
};

export default function BignumbersPedidos({ data, isMobile }) {
  const { billedOrdersLength, billedOrdersTotal } = getBilledOrders(data);
  const { nonBilledOrdersLength, nonBilledOrdersTotal } =
    getNonBilledOrders(data);

  return (
    <Grid container spacing={2}>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Total de Pedidos"
          value={nonBilledOrdersLength}
          icon={ListAlt}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Saldo em Aberto"
          value={"R$" + MaskAndValid.maskPrice(nonBilledOrdersTotal)}
          icon={AttachMoney}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Pedidos Faturados"
          value={billedOrdersLength}
          icon={Receipt}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Total Faturado"
          value={"R$" + MaskAndValid.maskPrice(billedOrdersTotal)}
          icon={Paid}
        />
      </Grid>
    </Grid>
  );
}
